import { render, staticRenderFns } from "./leftConfigPage.vue?vue&type=template&id=33e24acf&scoped=true"
import script from "./leftConfigPage.vue?vue&type=script&lang=js"
export * from "./leftConfigPage.vue?vue&type=script&lang=js"
import style0 from "./leftConfigPage.vue?vue&type=style&index=0&id=33e24acf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e24acf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e24acf')) {
      api.createRecord('33e24acf', component.options)
    } else {
      api.reload('33e24acf', component.options)
    }
    module.hot.accept("./leftConfigPage.vue?vue&type=template&id=33e24acf&scoped=true", function () {
      api.rerender('33e24acf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/config/leftConfigPage.vue"
export default component.exports